/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Horizontal_Padding_LabelInputs */

const en_options_display_horizontal_padding_label = /** @type {(inputs: Options_Display_Horizontal_Padding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horizontal Padding (%)`)
};

const fr_options_display_horizontal_padding_label = /** @type {(inputs: Options_Display_Horizontal_Padding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marge horizontale (%)`)
};

const de_options_display_horizontal_padding_label = /** @type {(inputs: Options_Display_Horizontal_Padding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horizontale Polsterung (%)`)
};

const it_options_display_horizontal_padding_label = /** @type {(inputs: Options_Display_Horizontal_Padding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riempimento orizzontale (%)`)
};

const ru_options_display_horizontal_padding_label = /** @type {(inputs: Options_Display_Horizontal_Padding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Горизонтальный отступ (%)`)
};

const es_options_display_horizontal_padding_label = /** @type {(inputs: Options_Display_Horizontal_Padding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relleno horizontal (%)`)
};

const zh_cn2_options_display_horizontal_padding_label = /** @type {(inputs: Options_Display_Horizontal_Padding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水平填充率 (%)`)
};

const ja_options_display_horizontal_padding_label = /** @type {(inputs: Options_Display_Horizontal_Padding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水平パディング（％）`)
};

const hi_options_display_horizontal_padding_label = /** @type {(inputs: Options_Display_Horizontal_Padding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्षैतिज पैडिंग (%)`)
};

const pt_pt2_options_display_horizontal_padding_label = /** @type {(inputs: Options_Display_Horizontal_Padding_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preenchimento horizontal (%)`)
};

/**
* | output |
* | --- |
* | "Horizontal Padding (%)" |
*
* @param {Options_Display_Horizontal_Padding_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_horizontal_padding_label = /** @type {((inputs?: Options_Display_Horizontal_Padding_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Horizontal_Padding_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_horizontal_padding_label(inputs)
	if (locale === "de") return de_options_display_horizontal_padding_label(inputs)
	if (locale === "it") return it_options_display_horizontal_padding_label(inputs)
	if (locale === "ru") return ru_options_display_horizontal_padding_label(inputs)
	if (locale === "es") return es_options_display_horizontal_padding_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_horizontal_padding_label(inputs)
	if (locale === "ja") return ja_options_display_horizontal_padding_label(inputs)
	if (locale === "hi") return hi_options_display_horizontal_padding_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_horizontal_padding_label(inputs)
	return en_options_display_horizontal_padding_label(inputs)
});